import React, { useEffect, useState } from "react";
import classes from "./RegisterComplete.module.scss";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { Navigate, useNavigate } from "react-router-dom";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import teacherIcon from "../../static/images/character/teacher-mail.png";
import { fetchUser } from "../../api/UsersApi";

const RegisterComplete = () => {
  const navigate = useNavigate();
  const [userdiagnosisType, setdiagnosisType] = useState<string | null>(null);
  const fetchUserApi = fetchUser();

  useEffect(() => {
    fetchUserApi.fetch();
  }, []);

  useEffect(() => {
    if (fetchUserApi.state?.data == null) {
      return;
    }

    const user = fetchUserApi.state?.data[0];
    const diagnosisType = user?.diagnosisType ?? "no_diagnosis";
    setdiagnosisType(diagnosisType);
  }, [fetchUserApi.state?.data]);

  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <img
          className={classes.teacherImage}
          src={teacherIcon}
          alt={teacherIcon}
        />
        <div className={classes.title}>本登録 完了</div>
        <div className={classes.caption}>ご登録ありがとうございます。</div>
        <div className={classes.button}>
          <SimpleButton
            label="ログインページへ"
            width="100%"
            color="orange"
            isRadius={true}
            onClick={() => navigate("/login")}
          ></SimpleButton>
        </div>
        <div className={classes.breadCrumb}>
          <BreadCrumb
            data={[
              { displayName: "みらいいコンシェル", url: "/login"},
              { displayName: "本登録" },
              { displayName: "完了" },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default RegisterComplete;
